import { render, staticRenderFns } from "./loanForm.vue?vue&type=template&id=4b4b027e&scoped=true"
import script from "./loanForm.vue?vue&type=script&lang=js"
export * from "./loanForm.vue?vue&type=script&lang=js"
import style0 from "./loanForm.vue?vue&type=style&index=0&id=4b4b027e&prod&scoped=true&lang=css"
import style1 from "./loanForm.vue?vue&type=style&index=1&id=4b4b027e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b027e",
  null
  
)

export default component.exports